import React, { useState } from "react";
import { Box, TextField, MenuItem, Typography } from "@mui/material";

export default function TimeSelector({ data, setInput, t, lang }) {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");

  const value = data.value;

  const dates = value.map((item) => Object.keys(item)[0]);

  const timesForSelected = selectedDate
    ? value.find((item) => item[selectedDate])?.[selectedDate] || []
    : [];

  const handleSelectDate = (date) => {
    setSelectedDate(date);
    setSelectedTime("");
    setInput("");

    if (date === "Aucune") {
      setSelectedTime("Aucune");
      setInput("Aucune");
    }
  };

  const handleSelectTime = (time) => {
    setSelectedTime(time);

    if (time === "Aucune") {
      setInput("Aucune");
    } else {
      setInput(`${selectedDate} ${time}`);
    }
  };

  return (
    <Box sx={{ mt: 0.5 }}>
      {/* DATE */}
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {t("selectDate", lang)}
      </Typography>

      <TextField
        select
        fullWidth
        size="small"
        value={selectedDate}
        // value={selectedDate || ""} // important
        displayEmpty
        // placeholder={t("selectDate", lang)}
        onChange={(e) => handleSelectDate(e.target.value)}
        slotProps={{
          select: {
            displayEmpty: true,
            renderValue: (selected) => {
              if (!selected || selected === "") {
                return <Typography sx={{ color: "text.secondary", opacity: 0.7, fontSize: "inherit" }}>{t("selectDate", lang)}</Typography>;
              }
              return selected;
            },
          }
        }}
        sx={{
          mt: 0.5,
          mb: 1,
          
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            bgcolor: "#eee",
          },
        }}
      >
        <MenuItem value="" disabled style={{ display: 'none' }}>
          -- {t("selectDate", lang)} --
        </MenuItem>

        {dates.map((d, i) => (
          <MenuItem key={i} value={d}>
            {d}
          </MenuItem>
        ))}
      </TextField>

      {/* TIME */}
      {selectedDate && (
        <>
          <Typography variant="caption" sx={{ fontWeight: 600 }}>
            {t("selectTime", lang)}
          </Typography>

          <TextField
            select
            fullWidth
            size="small"
            value={selectedTime}
            placeholder={t("selectTime", lang)}
            onChange={(e) => handleSelectTime(e.target.value)}
            slotProps={{
              select: {
                displayEmpty: true,
                renderValue: (selected) => {
                  if (!selected || selected === "") {
                    return <Typography sx={{ color: "text.secondary", opacity: 0.7, fontSize: "inherit" }}>{t("selectTime", lang)}</Typography>;
                  }
                  return selected;
                },
              }
            }}
            sx={{
              mt: 0.5,
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                bgcolor: "#eee",
              },
            }}
          >
            <MenuItem value="">
              -- {t("selectTime", lang)} --
            </MenuItem>

            {timesForSelected.map((time, i) => (
              <MenuItem key={i} value={time}>
                {time}
              </MenuItem>
            ))}
          </TextField>
        </>
      )}
    </Box>
  );
}